(() => {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree5c1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree5c1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $d05063f1a8a1aa4a$exports = {};
$parcel$extendImportMap({
    "ae5VW": "resources/favicons/apple-touch-icon.png",
    "g3KdU": "resources/favicons/favicon-32x32.png",
    "egVWS": "resources/favicons/favicon-16x16.png",
    "fY5XB": "resources/favicons/safari-pinned-tab.svg"
});

// favicons





const $7104c3b21fe5bce6$var$toggleNav = ()=>{
    const button = document.querySelector(".header .button");
    const mainNav = document.querySelector(".header .text");
    if (button && mainNav) button.addEventListener("click", ()=>{
        mainNav.classList.toggle("is-open");
    });
};
const $7104c3b21fe5bce6$var$toggleListItems = ()=>{
    const listItems = document.querySelectorAll(".header .cmp-container .cmp-text li");
    listItems.forEach((li)=>{
        li.addEventListener("click", (e)=>{
            if (e.target.closest(".no-toggle")) {
                e.preventDefault();
                return;
            }
            const parentUl = li.parentElement;
            const currentlyOpen = parentUl.querySelector("li.open");
            if (currentlyOpen === li) li.classList.toggle("open");
            else {
                if (currentlyOpen) currentlyOpen.classList.remove("open");
                li.classList.add("open");
            }
            e.stopPropagation();
        });
    });
};
const $7104c3b21fe5bce6$var$onDocumentReady = ()=>{
    const mainNav = document.getElementsByClassName("header");
    if (mainNav.length > 0) $7104c3b21fe5bce6$var$toggleNav();
    $7104c3b21fe5bce6$var$toggleListItems();
};
if (document.readyState !== "loading") $7104c3b21fe5bce6$var$onDocumentReady();
else document.addEventListener("DOMContentLoaded", $7104c3b21fe5bce6$var$onDocumentReady);


function $e5df6eaf61499330$var$cleanPrivacyPage() {
    function cleanSpaces(htmlText) {
        return htmlText.replace(/&nbsp;|\u00A0/g, ' ');
    }
    const originalSetHTML = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML').set;
    const originalInsertHTML = Element.prototype.insertAdjacentHTML;
    Object.defineProperty(Element.prototype, 'innerHTML', {
        set: function(htmlContent) {
            if (this.closest && this.closest('.privacy-page')) htmlContent = cleanSpaces(htmlContent);
            originalSetHTML.call(this, htmlContent);
        }
    });
    Element.prototype.insertAdjacentHTML = function(position, htmlContent) {
        if (this.closest && this.closest('.privacy-page')) htmlContent = cleanSpaces(htmlContent);
        originalInsertHTML.call(this, position, htmlContent);
    };
}
const $e5df6eaf61499330$var$onDocumentReady = ()=>{
    const privacyPage = document.getElementsByClassName(".privacy-page");
    if (privacyPage) $e5df6eaf61499330$var$cleanPrivacyPage();
};
if (document.readyState !== "loading") $e5df6eaf61499330$var$onDocumentReady();
else document.addEventListener("DOMContentLoaded", $e5df6eaf61499330$var$onDocumentReady);


let $3b6b212e5e8b97ab$var$originalHTML = "";
let $3b6b212e5e8b97ab$var$container = null;
function $3b6b212e5e8b97ab$var$toMobileExistingTables(tablesArray) {
    const colCount = 3;
    const mobileTables = [];
    if (!$3b6b212e5e8b97ab$var$originalHTML) {
        $3b6b212e5e8b97ab$var$container = tablesArray[0].parentNode;
        $3b6b212e5e8b97ab$var$originalHTML = $3b6b212e5e8b97ab$var$container.innerHTML;
    }
    for(let i = 0; i < colCount; i++){
        const mt = document.createElement("table");
        mt.classList.add("table--mobile");
        mt.style.width = "100%";
        const mtbody = document.createElement("tbody");
        mt.appendChild(mtbody);
        mobileTables.push({
            table: mt,
            tbody: mtbody
        });
    }
    tablesArray.forEach((table)=>{
        const tbodies = table.querySelectorAll("tbody");
        tbodies.forEach((tbody)=>{
            const rows = tbody.querySelectorAll("tr");
            rows.forEach((row)=>{
                const cells = row.querySelectorAll("td");
                cells.forEach((cell, colIndex)=>{
                    if (mobileTables[colIndex]) {
                        const tr = document.createElement("tr");
                        tr.appendChild(cell.cloneNode(true));
                        mobileTables[colIndex].tbody.appendChild(tr);
                    }
                });
            });
        });
    });
    $3b6b212e5e8b97ab$var$container.innerHTML = "";
    mobileTables.forEach((mt)=>$3b6b212e5e8b97ab$var$container.appendChild(mt.table));
}
function $3b6b212e5e8b97ab$var$toDesktopExistingTables() {
    if ($3b6b212e5e8b97ab$var$originalHTML && $3b6b212e5e8b97ab$var$container) $3b6b212e5e8b97ab$var$container.innerHTML = $3b6b212e5e8b97ab$var$originalHTML;
}
function $3b6b212e5e8b97ab$var$updateTables() {
    const allTables = Array.from(document.querySelectorAll(".otnotice-section-content table"));
    if (allTables.length < 4) return;
    const targetTables = allTables.slice(6, 10);
    if (window.innerWidth < 1024) $3b6b212e5e8b97ab$var$toMobileExistingTables(targetTables);
    else $3b6b212e5e8b97ab$var$toDesktopExistingTables();
}
function $3b6b212e5e8b97ab$var$initTablesOnceReady() {
    if (document.querySelectorAll(".otnotice-section-content table").length) {
        $3b6b212e5e8b97ab$var$updateTables();
        window.addEventListener("resize", $3b6b212e5e8b97ab$var$updateTables);
    } else {
        const poller = setInterval(()=>{
            if (document.querySelectorAll(".otnotice-section-content table").length) {
                clearInterval(poller);
                $3b6b212e5e8b97ab$var$updateTables();
                window.addEventListener("resize", $3b6b212e5e8b97ab$var$updateTables);
            }
        }, 300);
    }
}
if (document.readyState !== "loading") $3b6b212e5e8b97ab$var$initTablesOnceReady();
else document.addEventListener("DOMContentLoaded", $3b6b212e5e8b97ab$var$initTablesOnceReady);


const $9841b85372b1a63d$var$initDropdownTabs = (tabList, index)=>{
    if (!tabList) return;
    const listId = tabList.id || `tab-filter-${index}`;
    tabList.id = listId;
    const activeTab = tabList.querySelector(".cmp-tabs__tab--active") || tabList.querySelector("li[role='tab']");
    const activeText = activeTab ? activeTab.textContent.trim() : "";
    const button = document.createElement("button");
    button.className = "dropdown-selector expanded";
    button.setAttribute("aria-controls", listId);
    button.setAttribute("aria-expanded", "false");
    const textDiv = document.createElement("div");
    textDiv.className = "text";
    textDiv.textContent = activeText;
    const iconDiv = document.createElement("div");
    iconDiv.className = "icon";
    button.appendChild(textDiv);
    button.appendChild(iconDiv);
    tabList.parentNode.insertBefore(button, tabList);
    tabList.style.display = "none";
    button.addEventListener("click", ()=>{
        const expanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!expanded));
        tabList.style.display = expanded ? "none" : "flex";
    });
    const tabs = tabList.querySelectorAll("li[role='tab']");
    tabs.forEach((tab)=>{
        tab.addEventListener("click", ()=>{
            tabs.forEach((t)=>{
                t.classList.remove("cmp-tabs__tab--active");
                t.setAttribute("aria-selected", "false");
                t.setAttribute("tabindex", "-1");
            });
            tab.classList.add("cmp-tabs__tab--active");
            tab.setAttribute("aria-selected", "true");
            tab.setAttribute("tabindex", "0");
            textDiv.textContent = tab.textContent.trim();
            button.setAttribute("aria-expanded", "false");
            tabList.style.display = "none";
        });
    });
};
const $9841b85372b1a63d$var$onDocumentReady = ()=>{
    const tabLists = document.querySelectorAll(".faq ol[role='tablist']");
    tabLists.forEach((tabList, index)=>{
        $9841b85372b1a63d$var$initDropdownTabs(tabList, index);
    });
};
if (document.readyState !== "loading") $9841b85372b1a63d$var$onDocumentReady();
else document.addEventListener("DOMContentLoaded", $9841b85372b1a63d$var$onDocumentReady);


const $f3e4fe8f06eebf27$var$setupTabs = ()=>{
    const tabs = document.querySelectorAll('.tabs.country-selector li[role="tab"]');
    tabs.forEach((tab)=>{
        const panelId = tab.getAttribute("aria-controls");
        const panel = document.getElementById(panelId);
        if (panel) {
            const label = tab.textContent.trim();
            const container = panel.querySelector(".container");
            if (container) {
                const button = document.createElement("button");
                button.className = "tabpanel-button";
                button.setAttribute("aria-controls", panelId);
                button.textContent = label;
                panel.insertBefore(button, container);
                button.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    if (panel.classList.contains("cmp-tabs__tabpanel--active")) panel.classList.remove("cmp-tabs__tabpanel--active");
                    else {
                        document.querySelectorAll(".cmp-tabs__tabpanel").forEach((p)=>p.classList.remove("cmp-tabs__tabpanel--active"));
                        panel.classList.add("cmp-tabs__tabpanel--active");
                    }
                });
                panel.addEventListener("click", (e)=>{
                    if (!e.target.classList.contains("tabpanel-button")) panel.classList.remove("cmp-tabs__tabpanel--active");
                });
            }
        }
    });
};
const $f3e4fe8f06eebf27$var$onDocumentReady = ()=>{
    const tabsRoot = document.querySelector('.tabs.country-selector');
    if (tabsRoot) $f3e4fe8f06eebf27$var$setupTabs();
};
if (document.readyState !== "loading") $f3e4fe8f06eebf27$var$onDocumentReady();
else document.addEventListener("DOMContentLoaded", $f3e4fe8f06eebf27$var$onDocumentReady);


const $c2542b180d96c1ae$var$defaultMarket = "/us/en";
const $c2542b180d96c1ae$var$privacyNoticePath = '/notices/global-consumer-privacy-notice';
const $c2542b180d96c1ae$var$cookieNoticePath = '/notices/cookie-notice';
const $c2542b180d96c1ae$var$topLevelOneTrustId = 'onetrust-consent-sdk';
const $c2542b180d96c1ae$var$getInitialCurrentMarket = ()=>{
    const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})(?:\/|$)/);
    if (match) return `/${match[1]}/${match[2]}`;
    return $c2542b180d96c1ae$var$defaultMarket;
};
const $c2542b180d96c1ae$var$generateLink = (replacementPath)=>{
    return `${$c2542b180d96c1ae$var$getInitialCurrentMarket()}${replacementPath}`;
};
const $c2542b180d96c1ae$var$oneTrustItems = [
    {
        id: "onetrust-policy-text",
        link: "a.ot-cookie-policy-link",
        replacementPath: $c2542b180d96c1ae$var$generateLink($c2542b180d96c1ae$var$privacyNoticePath)
    },
    {
        id: "ot-pc-desc",
        link: "a.privacy-notice-link",
        replacementPath: $c2542b180d96c1ae$var$generateLink($c2542b180d96c1ae$var$privacyNoticePath)
    }
];
const $c2542b180d96c1ae$var$updateOneTrustLink = ()=>{
    const isOneTrustPresent = document.getElementById($c2542b180d96c1ae$var$topLevelOneTrustId);
    if (!isOneTrustPresent) return false;
    for (const oneTrustItem of $c2542b180d96c1ae$var$oneTrustItems){
        const oneTrustDescription = document.getElementById(oneTrustItem.id);
        if (!oneTrustDescription) continue;
        const oneTrustLink = oneTrustDescription.querySelector(oneTrustItem.link);
        if (!oneTrustLink) continue;
        oneTrustLink.href = oneTrustItem.replacementPath;
    }
    return true;
};
const $c2542b180d96c1ae$var$observeOneTrustBanner = ()=>{
    if ($c2542b180d96c1ae$var$updateOneTrustLink()) return;
    const maxAttempts = 5;
    let attempts = 0;
    const mutationObserver = new MutationObserver((_, observerInstance)=>{
        attempts++;
        if (attempts >= maxAttempts) {
            observerInstance.disconnect();
            return;
        }
        const updatedSuccessfully = $c2542b180d96c1ae$var$updateOneTrustLink();
        if (updatedSuccessfully) observerInstance.disconnect();
    });
    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
};
if (document.readyState !== "loading") $c2542b180d96c1ae$var$observeOneTrustBanner();
else document.addEventListener("DOMContentLoaded", $c2542b180d96c1ae$var$observeOneTrustBanner);


const $65de88e2da0188ec$var$openPreferenceCenterLinkHash = '#js-open-onetrust-preference-center';
const $65de88e2da0188ec$var$openPreferenceCenterLinkSelector = `a[href="${$65de88e2da0188ec$var$openPreferenceCenterLinkHash}"]`;
const $65de88e2da0188ec$var$toggleOneTrustPreferenceCenter = ()=>{
    document.querySelector($65de88e2da0188ec$var$openPreferenceCenterLinkSelector)?.addEventListener('click', (event)=>{
        event.preventDefault();
        if (window.Optanon && typeof window.Optanon.ToggleInfoDisplay === 'function') window.Optanon.ToggleInfoDisplay();
    });
};
if (document.readyState !== "loading") $65de88e2da0188ec$var$toggleOneTrustPreferenceCenter();
else document.addEventListener("DOMContentLoaded", $65de88e2da0188ec$var$toggleOneTrustPreferenceCenter);



})();
//# sourceMappingURL=theme.js.map
